import { inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, NavigationEnd, CanActivateFn } from '@angular/router';
import { filter, Observable } from 'rxjs';

// Services
import { NetworkService } from '../../services/network/network.service';

export const RouteGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const network = inject(NetworkService);

  return new Observable((observer) => {
    router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      network.previousUrl = network.currentUrl;
      network.currentUrl = state.url;
    });

    observer.next(true);
  });
};
